var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from './base.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../authorization.service";
import * as i3 from "../message.service";
import * as i4 from "../cache.service";
var UserSettingsService = /** @class */ (function (_super) {
    __extends(UserSettingsService, _super);
    function UserSettingsService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpointUri = 'UserSettings';
        return _this;
    }
    UserSettingsService.prototype.getAll = function () {
        return this.getAllRequest();
    };
    UserSettingsService.prototype.get = function (id) {
        return this.getRequest(id);
    };
    UserSettingsService.prototype.getSettings = function (settingsKey) {
        return this.getRequest(settingsKey, this.endpointUri);
    };
    UserSettingsService.prototype.createSettings = function (settingsKey, settingsModel) {
        return this.patchRequest(settingsKey, this.endpointUri, settingsModel, null);
    };
    UserSettingsService.prototype.deleteSettings = function (settingsKey, settingsModel) {
        if (settingsModel === void 0) { settingsModel = undefined; }
        return this.updateRequest(settingsKey, this.endpointUri, settingsModel, null);
    };
    UserSettingsService.prototype.add = function () {
        throw new Error('Method not implemented.');
    };
    UserSettingsService.prototype.update = function () {
        throw new Error('Method not implemented.');
    };
    UserSettingsService.prototype.delete = function () {
        throw new Error('Method not implemented.');
    };
    UserSettingsService.ngInjectableDef = i0.defineInjectable({ factory: function UserSettingsService_Factory() { return new UserSettingsService(i0.inject(i1.HttpClient), i0.inject(i2.AuthorizationService), i0.inject(i3.MessageService), i0.inject(i4.CacheService)); }, token: UserSettingsService, providedIn: "root" });
    return UserSettingsService;
}(BaseService));
export { UserSettingsService };
